<template>
  <div class="formField textareaField" :class="{ hasFocus, hasValue, isError, isDisabled, isInline }">
    <slot />
    <FormLabel v-bind="formLabelProps">
      <slot name="tooltip" />
    </FormLabel>
    <span class="textareaField__Info form__Info" v-html="info" v-if="info" />
    <div class="textareaField__Wrapper">
      <textarea
        :id="uniqueID"
        :name="name"
        :disabled="isDisabled"
        :required="isRequired"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :tabindex="isDisabled ? -1 : 0"
        @focus="setFocus(true)"
        @blur="setFocus(false)"
        v-model="fieldValue"
      />
      <span v-text="`${fieldValue.length} / ${maxlength}`" v-if="maxlength" />
    </div>

    <FormError :errors="mergedErrors" className="textareaField__Error" />
  </div>
</template>

<script setup>
  const emit = defineEmits(['update:modelValue'])
  const props = defineProps({
    ...useFormFieldProps(),
    placeholder: {
      type: [String, Number]
    },
    maxlength: {
      type: Number
    }
  })

  const {
    isError,
    isInline,
    isDisabled,
    isRequired,
    fieldValue,
    mergedErrors,
    uniqueID,
    hasValue,
    formLabelProps,
    hasFocus,
    setFocus,
    triggerValidate,
  } = useFormField(props, emit)

  defineExpose({
    triggerValidate,
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/components/forms/_textareaField.scss');
</style>
